import { getOidcVerifier, setOidcVerifier } from '~/utils/local-storage-utils/local-storage-utils';
import {
  digestMessage,
  generateRandomString,
  isValidCodeVerifier,
} from '~/domain/auth/utils/crypto';
import { authConfig } from '~/config/app';

export const composeBaseUrl = (challengeCode) => {
  return String(authConfig.oidcUrl)
    .concat('?client_id=')
    .concat(String(authConfig.oidcClientId))
    .concat('&response_type=code')
    .concat('&scope=iam:read iam:write openid profile email')
    .concat('&redirect_uri=')
    .concat(encodeURIComponent(String(authConfig.oidcRedirectUrl)))
    .concat('&code_challenge=')
    .concat(challengeCode)
    .concat('&code_challenge_method=S256');
};

export const composeLoginUrl = (challengeCode) => {
  return composeBaseUrl(challengeCode).concat('&reset-session=true');
};

export const composeLogoutUrl = (challengeCode) => {
  const logoutRedirectUrl = authConfig.oidcLogoutRedirectUrl;
  const base = composeBaseUrl(challengeCode).concat('&reset-session=true');

  if (!logoutRedirectUrl) {
    return base;
  }

  return base.concat('&logout_redirect_uri=').concat(encodeURIComponent(String(logoutRedirectUrl)));
};

export const createOidcLoginUrl = async () => {
  const storedVerifier = getOidcVerifier();
  const verifierCode = isValidCodeVerifier(storedVerifier)
    ? storedVerifier
    : generateRandomString();
  setOidcVerifier(verifierCode);
  const challengeCode = await digestMessage(verifierCode);
  return composeLoginUrl(challengeCode);
};
